<template>
  <div class="bg-white py-4">
    <div class="row justify-between align-center px-4">
      <span class="text-black text-24 font-bold letter-spacing-1">{{ $t('uploadImage') }}</span>
      <button
        class="close text-black justify-center row align-center font-bold"
        @click="$emit('close')"
      >
        <i class="isif isif-close" />
      </button>
    </div>
    <div class="row mt-6 justify-center bg-light-gray">
      <vue-avatar
        ref="vueavatar"
        :width="width"
        :height="height"
        :rotation="0"
        :scale="scale"
        :border-radius="borderRadius"
      />
    </div>
    <div class="row justify-center mt-6 align-center">
      <input
        v-model="scaleOrigin"
        :min="min"
        :max="max"
        step="0.02"
        type="range"
      >
    </div>
    <div class="justify-between mt-6 row align-center px-4">
      <button
        class="cancel-btn"
        @click="$emit('close')"
      >
        {{ $t('cancel') }}
      </button>
      <button
        class="save-btn"
        @click="saveClicked"
      >
        {{ $t('favorites.note.saved') }}
      </button>
    </div>
  </div>
</template>

<script>
import { VueAvatar } from 'vue-avatar-editor-improved'
export default {
  components: {
    VueAvatar
  },
  props: {
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 200
    },
    borderRadius: {
      type: Number,
      default: 100
    },
    max: {
      type: Number,
      default: 3
    },
    min: {
      type: Number,
      default: 1
    },
    type: {
      type: String,
      default: 'profile'
    }
  },
  data () {
    return {
      scaleOrigin: 1
    }
  },
  computed: {
    scale () {
      return Number(this.scaleOrigin)
    }
  },
  methods: {
    saveClicked () {
      const img = this.$refs.vueavatar.getImageScaled()
      this.$emit('save', { type: this.type, img: img.toDataURL() })
      this.$emit('close')
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/colors'
@import '~css/addon/main'
h1, h2, h3, h4, h5, h6, p, a, span, small {
  text-shadow: none
}
.row {
  display: flex
}
.justify-between {
  justify-content: space-between
}
.justify-center {
  justify-content: center
}
.align-center {
  align-items: center
}
.bg-white {
  background-color: $white
}
.bg-light-gray {
  background-color: $light-gray-color
}
.text-black {
  color: $vrl-primary-text
}
.letter-spacing-1 {
  letter-spacing: 1px
}
.text-24 {
  font-size: 24px
}
.font-bold {
  font-weight: 700
}
.close {
  background-color: transparent
  width: 24px
  height: 24px
}
.py-4 {
  padding-top: 16px
  padding-bottom: 16px
}
.px-4 {
  padding-left: 16px
  padding-right: 16px
}
.mt-6 {
  margin-top: 24px
}
.cancel-btn, .save-btn {
  padding: 6px 20px
  border-radius: 4px
  font-size: 16px
}
.cancel-btn {
  background-color: $light-gray-color2
  color: $gray
}
.save-btn {
  background-color: $pink-color
  color: $white
}
</style>
